<template>
  <div>
    <!-- Selector de periodo (solo prestador) -->
    <div class="input-group my-3" v-if="prestador">
      <table class="table table-striped">
        <tbody>
          <tr>
            <td class="text-start col-50">
              <label for="cargaSeleccionada"><b>Seleccione un periodo:</b></label>
            </td>
            <td>
              <select
                id="cargaSeleccionada"
                name="cargaSeleccionada"
                v-model="cargaSeleccionada"
                class="form-select"
                @change="handleSelection"
              >
                <option v-for="carga in cargas" :key="carga.idCarga" :value="carga.idCarga">
                  {{ getFormattedDate(carga.fechaDesde) }} -
                  {{ getFormattedDate(carga.fechaHasta) }} -
                  {{ carga.tipoCarga === 'M' ? 'Mensual' : carga.tipoCarga === 'S' ? 'Semanal' : carga.tipoCarga === 'A' ? 'Autorización' : carga.tipoCarga }}
                </option>
              </select>
            </td>
            <td class="text-end w-50">
              <button @click="exportarCSV" class="btn btn-success">Exportar a CSV</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


<!-- Barra de acciones -->
<div class="row g-2 align-items-center mb-3 mt-2">
  <div class="col-auto">
    <button @click="exportarEmpresaCSV" class="btn btn-success btn-sm d-flex align-items-center gap-1">
      <span class="material-icons" style="font-size:16px">download</span> Exportar CSV
    </button>
  </div>
  <div class="col-auto">
    <button @click="exportToExcel" class="btn btn-info btn-sm d-flex align-items-center gap-1">
      <span class="material-icons" style="font-size:16px">download</span> Exportar Excel
    </button>
  </div>
  <div class="col-auto" v-if="p_tipoConsulta == 'MANUALES'">
    <button @click="abrirCrear(0)" class="btn btn-primary btn-sm d-flex align-items-center gap-1">
      <span class="material-icons" style="font-size:16px">add</span> Registro
    </button>
  </div>

  <!-- ── Botón Todos (antes en la barra de filtros) ── -->
  <div class="col-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
      @click.prevent="getDataPaginaTodos(1)" title="Recargar todos los registros">
      <span class="material-icons" style="font-size:16px">refresh</span> Todos
    </button>
  </div>

  <!-- Selector registros por página -->
  <div class="col-auto ms-auto d-flex align-items-center gap-2">
    <label class="form-label mb-0 small fw-bold">Mostrar</label>
    <select v-model.number="elementosPorPagina" class="form-select form-select-sm"
      style="width:75px" @change="cambiarElementosPorPagina">
      <option :value="10">10</option>
      <option :value="25">25</option>
      <option :value="50">50</option>
      <option :value="100">100</option>
    </select>
    <span class="small text-muted">registros</span>
  </div>
</div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="planillas.length > 0">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
<thead class="table-dark">
  <!-- Fila de encabezados (sin cambios) -->
  <tr>
    <th class="th-sort" @click="ordenarPor('numero')">
      Número <span>{{ iconOrden('numero') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('fechaDesde')">
      F. Atención <span>{{ iconOrden('fechaDesde') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('cedula')">
      Cédula <span>{{ iconOrden('cedula') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('nombre')">
      Nombre <span>{{ iconOrden('nombre') }}</span>
    </th>
    <th v-if="estadoAM" class="th-sort" @click="ordenarPor('diag1')">
      Diag1 <span>{{ iconOrden('diag1') }}</span>
    </th>
    <th v-if="estadoAM" class="th-sort" @click="ordenarPor('estadoAud')">
      Estado AM <span>{{ iconOrden('estadoAud') }}</span>
    </th>
    <th v-if="estadoGD" class="th-sort" @click="ordenarPor('estadoDoc')">
      Estado GD <span>{{ iconOrden('estadoDoc') }}</span>
    </th>
    <th class="th-sort" @click="ordenarPor('idCarga')">
      Periodo <span>{{ iconOrden('idCarga') }}</span>
    </th>
    <th v-if="mostrarElemento">Opciones</th>
    <th v-if="estadoGD"></th>
  </tr>
  <!-- Fila de filtros por columna -->
  <tr>
    <th>
      <input v-model="filtroNumero" @input="aplicarPaginacion(1)"
        class="form-control form-control-sm" placeholder="Filtrar..." />
    </th>
<th>
  <input
    type="date"
    v-model="filtroFechaAtencion"
    @change="aplicarPaginacion(1)"
    class="form-control form-control-sm"
    :min="(p_tramite.fechaDesde ?? '').slice(0, 10)"
    :max="(p_tramite.fechaHasta ?? '').slice(0, 10)"
  />
</th>
    <th>
      <input v-model="filtroCedula" @input="aplicarPaginacion(1)"
        class="form-control form-control-sm" placeholder="Filtrar..." />
    </th>
    <th>
      <input v-model="filtroNombre" @input="aplicarPaginacion(1)"
        class="form-control form-control-sm" placeholder="Filtrar..." />
    </th>
    <th v-if="estadoAM">
      <input v-model="filtroDiag1" @input="aplicarPaginacion(1)"
        class="form-control form-control-sm" placeholder="Filtrar..." />
    </th>
    <th v-if="estadoAM">
      <select v-model="filtroEstadoAM" @change="aplicarPaginacion(1)"
        class="form-select form-select-sm">
        <option value="">Todos</option>
        <option value="PENDIENTE">PENDIENTE</option>
        <option value="REVISADA">REVISADA</option>
        <option value="FINALIZADA">FINALIZADA</option>
      </select>
    </th>
    <th v-if="estadoGD">
      <select v-model="filtroEstadoGD" @change="aplicarPaginacion(1)"
        class="form-select form-select-sm">
        <option value="">Todos</option>
        <option value="PENDIENTE">PENDIENTE</option>
        <option value="REVISADA">REVISADA</option>
        <option value="FINALIZADA">FINALIZADA</option>
      </select>
    </th>
    <th>
      <select v-model="filtroIdCarga" @change="aplicarPaginacion(1)"
        class="form-select form-select-sm">
        <option value="">Todos</option>
        <option v-for="carga in cargas" :key="carga.idCarga" :value="String(carga.idCarga)">
          {{ getFormattedDate(carga.fechaDesde) }}
        </option>
      </select>
    </th>
    <th v-if="mostrarElemento"></th>
    <th v-if="estadoGD"></th>
  </tr>
</thead>
        <tbody>
          <tr
            v-for="planilla in datosPaginados"
            :key="planilla.idPlanilla"
            @dblclick="handleRowClick($event, planilla.idPlanilla, planilla.estadoAud)"
          >
            <td>{{ planilla.numero }}</td>
            <td>{{ getFormattedDate(planilla.fechaDesde) }}</td>
            <td>{{ planilla.cedula }}</td>
            <td>{{ planilla.nombre }}</td>
<!--
            <td>{{ planilla.cedulaMedico }}</td>
-->
            <td v-if="estadoAM">{{ planilla.diag1 }}</td>
            <td v-if="estadoAM">
              <span class="badge" :class="badgeEstado(planilla.estadoAud)">{{ planilla.estadoAud }}</span>
            </td>
            <td v-if="estadoGD">
              <span class="badge" :class="badgeEstado(planilla.estadoDoc)">{{ planilla.estadoDoc }}</span>
            </td>
<!--
            <td>
              <span v-if="planilla.duplicada === 1" class="material-symbols-outlined text-success">check</span>
            </td>
-->
            <td>{{ getFechaDesdeByIdCarga(planilla.idCarga) }}</td>
            <td v-if="mostrarElemento">
              <select class="form-select form-select-sm"
                @change="handleAction($event, planilla.idPlanilla)"
                :disabled="p_tramite.estadoTramite === 'FINALIZADO'">
                <option disabled selected>Seleccione...</option>
                <option v-if="planilla.estadoAud === 'ELABORACION'" value="elaboracion">Elaboración</option>
                <option value="resumen">Resumen</option>
                <option v-if="estadoGD" value="detalles">Detalles</option>
              </select>
            </td>
<!--			
            <td></td>
-->			
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="9" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ planillasOrdenadas.length }} atenciones
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div v-else class="alert alert-info text-center mt-3">No hay atenciones registradas.</div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="planillas.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ planillasOrdenadas.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="irPrimeraPagina">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li v-for="pagina in paginasVisibles" :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }">
            <a class="page-link" href="#" @click.prevent="pagina !== '...' && irAPagina(pagina)">
              {{ pagina }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="irUltimaPagina">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <!-- NAV TABS -->
          <ul class="nav nav-tabs px-3 pt-2" id="tabsPlanilla" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="tab-uno" data-bs-toggle="tab"
                data-bs-target="#contenido-uno" type="button" role="tab"
                aria-controls="contenido-uno" aria-selected="true">
                Información
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="tab-dos" data-bs-toggle="tab"
                data-bs-target="#contenido-dos" type="button" role="tab"
                aria-controls="contenido-dos" aria-selected="false">
                Archivos
              </button>
            </li>
          </ul>
          <!-- CONTENIDOS -->
          <div class="tab-content p-3">
            <!-- TAB 1 -->
            <div class="tab-pane fade show active" id="contenido-uno" role="tabpanel" aria-labelledby="tab-uno">
              <form class="border rounded shadow p-3">
                <h5 class="mb-3 text-primary">Información General</h5>
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr><th>Trámite</th><th>Número</th><th>Planilla</th><th>Estado AM</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ datoPlanilla.idTramite }}</td>
                      <td>{{ datoPlanilla.numero }}</td>
                      <td>{{ datoPlanilla.idPlanilla }}</td>
                      <td>{{ datoPlanilla.estadoAud }}</td>
                    </tr>
                  </tbody>
                </table>
                <h5 class="mt-4 mb-3 text-primary">Datos Personales</h5>
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr><th>Cédula</th><th>Nombre</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ datoPlanilla.cedula }}</td>
                      <td>{{ datoPlanilla.nombre }}</td>
                    </tr>
                  </tbody>
                </table>
                <h5 class="mt-4 mb-3 text-primary">Diagnósticos</h5>
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr><th v-for="i in 5" :key="i">Diag0{{ i }}</th></tr>
                  </thead>
                  <tbody>
                    <tr><td v-for="i in 5" :key="i">{{ datoPlanilla["diag0" + i] }}</td></tr>
                  </tbody>
                </table>
                <h5 class="mt-4 mb-3 text-primary">Periodo de Atención</h5>
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr><th>Fecha Desde</th><th>Fecha Hasta</th><th>Hora Desde</th><th>Hora Hasta</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ getFormattedDate(datoPlanilla.fechaDesde) }}</td>
                      <td>{{ getFormattedDate(datoPlanilla.fechaHasta) }}</td>
                      <td>{{ datoPlanilla.horaDesde }}</td>
                      <td>{{ datoPlanilla.horaHasta }}</td>
                    </tr>
                  </tbody>
                </table>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn-light"
                  @click.prevent="abrirPlanillaPDF(datoPlanilla.idPlanilla)"
                  v-if="idPerfil === 15" title="Imprimir">
                  <span class="material-symbols-outlined" style="font-size:32px; color:blue; cursor:pointer">print</span>
                </button>
              </div>
            </div>
            <!-- TAB 2 -->
            <div class="tab-pane fade" id="contenido-dos" role="tabpanel" aria-labelledby="tab-dos">
              <ArchivoPlaDatos
                v-if="datoPlanilla.idTramite != null && datoPlanilla.idPlanilla != null"
                :p_idTramite="Number(datoPlanilla.idTramite)"
                :p_idPlanilla="Number(datoPlanilla.idPlanilla)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import config from '@/config';
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import ArchivoPlaDatos from "../forms/ArchivoPlaDatos.vue";
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;

export default {
  props: {
    p_tramite:      { type: Object, required: true },
    p_tipoConsulta: { type: String, required: true },
  },
  components: { ArchivoPlaDatos },

  data() {
    return {
      planillas:                [],
      datoPlanilla:             {},
      titulo:                   "",
      elementosPorPagina:       10,
      datosPaginados:           [],
      paginaActual:             1,
      modalWindow:              true,
      idPerfil:                 0,
      idUsuario:                0,
      cargas:                   [],
      cargaSeleccionada:        null,
      // ── Ordenamiento ──────────────────────────────────────
      campoOrden:               'numero',
      ascendente:               true,
filtroNumero:    '',
filtroFechaAtencion: '',
filtroCedula:    '',
filtroNombre:    '',
filtroDiag1:     '',
filtroEstadoAM:  '',
filtroEstadoGD:  '',
filtroIdCarga:   '',
    };
  },

  computed: {
    mostrarElemento() {
      return (Number(this.idPerfil) >= 16 && Number(this.idPerfil) <= 20) || Number(this.idPerfil) == 1 || Number(this.idPerfil) == 22;
//      return Number(this.idPerfil) == 1 || (Number(this.idPerfil) >= 16 && Number(this.idPerfil) <= 20);
    },
    prestador() {
      return this.idPerfil == 15;
    },
    estadoAM() {
      return (
        (this.idPerfil == 1 || this.idPerfil == 16 || this.idPerfil == 17 || this.idPerfil == 18 || this.idPerfil == 22) &&
        (this.p_tramite.estadoTramite === "RECIBIDO" || this.p_tramite.estadoTramite === "EN PROCESO")
      );
    },
    estadoGD() {
      return (
        (this.idPerfil == 1 || this.idPerfil == 16 || this.idPerfil == 19 || this.idPerfil == 20) &&
        (this.p_tramite.estadoTramite === "RECIBIDO" || this.p_tramite.estadoTramite === "EN PROCESO")
      );
    },
    gestionDocumental() {
      return this.idPerfil == 20 && this.p_tramite.estadoTramite === "EN PROCESO";
    },

    // ── Array ordenado (base para paginación y exports) ────
planillasOrdenadas() {
  const campo = this.campoOrden;

  // ── Filtros de columna ─────────────────────────────
  let lista = this.planillas.filter(p => {
    const num  = this.filtroNumero   ? String(p.numero  ?? '').toLowerCase().includes(this.filtroNumero.toLowerCase())   : true;
    const fec = this.filtroFechaAtencion ? (p.fechaDesde ?? '').slice(0, 10) === this.filtroFechaAtencion                : true;
    const ced  = this.filtroCedula   ? String(p.cedula  ?? '').toLowerCase().includes(this.filtroCedula.toLowerCase())   : true;
    const nom  = this.filtroNombre   ? String(p.nombre  ?? '').toLowerCase().includes(this.filtroNombre.toLowerCase())   : true;
    const dg1  = this.filtroDiag1    ? String(p.diag1   ?? '').toLowerCase().includes(this.filtroDiag1.toLowerCase())    : true;
    const eAM  = this.filtroEstadoAM ? String(p.estadoAud ?? '').toLowerCase().includes(this.filtroEstadoAM.toLowerCase()) : true;
    const eGD  = this.filtroEstadoGD ? String(p.estadoDoc ?? '').toLowerCase().includes(this.filtroEstadoGD.toLowerCase()) : true;
    const carg = this.filtroIdCarga  ? String(p.idCarga  ?? '').includes(this.filtroIdCarga) : true;
    return num && ced && nom && dg1 && eAM && eGD && carg && fec;
  });

  // ── Ordenamiento ───────────────────────────────────
  return lista.sort((a, b) => {
    let va = a[campo] ?? '';
    let vb = b[campo] ?? '';
    if (campo === 'numero') {
      const na = parseInt(va, 10);
      const nb = parseInt(vb, 10);
      if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
    }
    const cmp = typeof va === 'number'
      ? va - vb
      : String(va).localeCompare(String(vb), 'es');
    return this.ascendente ? cmp : -cmp;
  });
},

    // ── Números de página con puntos suspensivos ───────────
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];

      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                    rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');

      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },

    urlSupervisor() {
      if (this.p_tipoConsulta == "TODAS")       return `/vwplanillas/idtramite/${this.p_tramite.idTramite}`;
      const esPerfilAud = this.idPerfil == 17 || this.idPerfil == 22;

      if (this.p_tipoConsulta === "PENDIENTES") return esPerfilAud
        ? `/vwplanillas/estadoaud/${this.p_tramite.idTramite}/PENDIENTE`
        : `/vwplanillas/estadodoc/${this.p_tramite.idTramite}/PENDIENTE`;

      if (this.p_tipoConsulta == "REVISADAS") return esPerfilAud
        ? `/vwplanillas/estadoaud/${this.p_tramite.idTramite}/REVISADA`
        : `/vwplanillas/estadodoc/${this.p_tramite.idTramite}/REVISADA`;
      if (this.p_tipoConsulta == "MANUALES")    return `/vwplanillas/idtramite-manuales/${this.p_tramite.idTramite}`;
      return `/vwplanillas/idtramite/${this.p_tramite.idTramite}`;
    },
    urlOperativo() {
      if (this.p_tipoConsulta == "TODAS") {
        if (this.idPerfil == 18) return `/vwplanillas/tramite-usuario/${this.p_tramite.idTramite}/med/${this.idUsuario}`;
        if (this.idPerfil == 20) return `/vwplanillas/tramite-usuario/${this.p_tramite.idTramite}/doc/${this.idUsuario}`;
      }
      if (this.p_tipoConsulta === "PENDIENTES") {
        if (this.idPerfil == 18) return `/vwplanillas/estadoaud-usuario/${this.p_tramite.idTramite}/${this.idUsuario}/PENDIENTE`;
        if (this.idPerfil == 20) return `/vwplanillas/estadodoc-usuario/${this.p_tramite.idTramite}/${this.idUsuario}/PENDIENTE`;
      }
      if (this.p_tipoConsulta == "REVISADAS") {
        if (this.idPerfil == 18) return `/vwplanillas/estadoaud-usuario/${this.p_tramite.idTramite}/${this.idUsuario}/REVISADA`;
        if (this.idPerfil == 20) return `/vwplanillas/estadodoc-usuario/${this.p_tramite.idTramite}/${this.idUsuario}/REVISADA`;
      }
      if (this.p_tipoConsulta == "MANUALES") return `/vwplanillas/idtramite-manuales/${this.p_tramite.idTramite}`;
      return `/vwplanillas/idtramite/${this.p_tramite.idTramite}`;
    },
cargaMap() {
  const map = {};
  this.cargas.forEach(c => { map[c.idCarga] = c; });
  return map;
},	
  },

  mounted() {
    this.idPerfil  = window.sessionStorage.getItem("idPerfil");
    this.idUsuario = window.sessionStorage.getItem("idUsuario");
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchCargas();
  },

  methods: {
    // ── Ordenamiento ───────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(this.paginaActual);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },
    badgeEstado(estado) {
      return {
        'bg-warning text-dark': estado === 'PENDIENTE',
        'bg-success':           estado === 'REVISADA',
        'bg-primary':           estado === 'FINALIZADA',
        'bg-secondary':         !['PENDIENTE', 'REVISADA', 'FINALIZADA'].includes(estado),
      };
    },

    // ── Paginación ─────────────────────────────────────────
    totalPaginas() {
      return Math.max(1, Math.ceil(this.planillasOrdenadas.length / this.elementosPorPagina));
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual   = noPagina;
      const ini           = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.planillasOrdenadas.slice(ini, ini + this.elementosPorPagina);
    },
    cambiarElementosPorPagina() {
      this.aplicarPaginacion(1);
    },
    irAPagina(pagina) {
      if (pagina >= 1 && pagina <= this.totalPaginas()) this.aplicarPaginacion(pagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },
    irPrimeraPagina() {
      this.aplicarPaginacion(1);
    },
    irUltimaPagina() {
      this.aplicarPaginacion(this.totalPaginas());
    },

    // ── Carga de datos ─────────────────────────────────────
    setPaginacion(planillas, noPagina) {
      this.planillas = planillas;
      this.aplicarPaginacion(noPagina);
    },
    async fetchData(url, paginar = false, noPagina = 1) {
      try {
        const response = await api.get(url);
        const data = response.data;
        if (paginar) {
          this.setPaginacion(data, noPagina);
        } else {
          this.planillas      = Array.isArray(data) ? data : [];
          this.datosPaginados = this.planillas;
        }
      } catch (error) {
        console.error("Error al recuperar los datos:", error);
        this.datosPaginados = [];
      }
    },
    getDataPaginaTodos(noPagina, resetFiltros = true) {
      if (resetFiltros) this.resetAllFilters();
      let url;
      if (this.p_tipoConsulta == 'ANULADAS') {
        url = `/vwplanillas/idtramite-anuladas/${this.p_tramite.idTramite}`;
      } else if (this.p_tipoConsulta === "MANUALES") {
        url = `/vwplanillas/idtramite-manuales/${this.p_tramite.idTramite}`;
      } else {
        if (this.idPerfil == 1 || this.idPerfil == 16 || this.idPerfil == 17 || this.idPerfil == 19 || this.idPerfil == 22 || this.p_tramite.tipoAsignacion == "T") {
          url = this.urlSupervisor;
        } else if (this.idPerfil == 18 || this.idPerfil == 20) {
          url = this.urlOperativo;
        }
      }
      api.get(url).then((response) => {
        this.setPaginacion(response.data, noPagina);
      });
    },
    refrescar() {
      this.getDataPaginaTodos(this.paginaActual, false);
    },	

    // ── Filtros ────────────────────────────────────────────
resetAllFilters() {
  this.cargaSeleccionada   = null;
  this.filtroNumero        = '';
  this.filtroFechaAtencion = '';
  this.filtroCedula        = '';
  this.filtroNombre        = '';
  this.filtroDiag1         = '';
  this.filtroEstadoAM      = '';
  this.filtroEstadoGD      = '';
  this.filtroIdCarga       = '';
},

    // ── Acciones de fila ───────────────────────────────────
    handleRowClick(event, idPlanilla, estadoAud) {
      if (event.target.tagName === "SELECT" || event.target.tagName === "OPTION") return;
      if (this.idPerfil == 15) {
        this.abrirModalEditar(idPlanilla);
      }
      if ([17, 18, 19, 20, 22].includes(Number(this.idPerfil))) {
        Number(this.idPerfil) === 17 && estadoAud === 'ELABORACION'
          ? this.abrirCrear(idPlanilla)
          : this.abrirEditar(idPlanilla);
      }
    },
    handleAction(event, idPlanilla) {
      const action = event.target.value;
      if      (action === "resumen")     this.abrirModalEditar(idPlanilla);
      else if (action === "elaboracion") this.abrirCrear(idPlanilla);
      else if (action === "detalles")    this.abrirEditar(idPlanilla);
      else if (action === "restablecer") this.restablecer(idPlanilla);
      else if (action === "borrar")      this.deleteTramite(idPlanilla);
      event.target.value = "Seleccione...";
    },

    // ── Modales y navegación ───────────────────────────────
    abrirModalEditar(idPlanilla) {
      this.modalWindow = true;
      if (idPlanilla != null) {
        api.get("/vwplanillas/" + idPlanilla).then(resp => { this.datoPlanilla = resp.data; });
      }
      $("#ventanaModal").modal("show");
      this.titulo    = "Resumen de la atención médica";
    },
    abrirEditar(idPlanilla) {
      if (idPlanilla == null) return;

      const params = new URLSearchParams({
        idTramite:     this.p_tramite.idTramite,
        idServicio:    this.p_tramite.idServicio,
        estadoTramite: this.p_tramite.estadoTramite,
        idPlanilla,
        tipoConsulta:  this.p_tipoConsulta,
      });

      if (this.p_tipoConsulta === "MANUALES") {
        this.$router.push(
          `/planillacrearform/${this.p_tramite.idTramite}/${idPlanilla}`
        );
      } else {
        window.open(`/planillaformpopup?${params.toString()}`, '_blank');
      }
    },
    abrirCrear(idPlanilla) {
      this.$router.push(`/planillacrearform/${this.p_tramite.idTramite}/${idPlanilla}`);
    },
    abrirPlanillaPDF(p_idPlanilla) {
      window.open(config.apiBaseUrl + "/reportes/pdf/9/" + p_idPlanilla, "_blank");
    },

    // ── Utilidades ─────────────────────────────────────────
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },
    formatFecha(fecha)     { return fecha ? fecha.split("T")[0] : ""; },
    validarForm() {
      const fields = ["idTramite","numero","cedula","nombre","diag1","diag2","diag3","diag4","diag5",
                      "fechaDesde","fechaHasta","horaDesde","horaHasta","estadoAud"];
      return validarForm(this.datoPlanilla, fields, fields);
    },
    async fetchCargas() {
      try {
        const response = await api.get(`/vwcargas/activas-por-tramite/${this.p_tramite.idTramite}`);
        this.cargas = response.data;
      } catch (e) { console.error("Error al obtener cargas:", e); }
    },
    async deletePlanilla(idPlanilla) {
      try {
        await api.delete("/planillas/" + idPlanilla);
        this.getDataPaginaTodos(this.paginaActual);
      } catch { alert("No se pudo eliminar"); }
    },

    // ── Exportaciones ──────────────────────────────────────
    exportarCSV() {
      if (!this.planillas.length) { alert("No hay datos para exportar."); return; }
      let csv = "data:text/csv;charset=utf-8,";
      csv += "ID Planilla;Número;Fecha de atención;Cédula;Nombre;Cédula médico\n";
      this.planillas.forEach(p => {
        csv += `${p.idPlanilla};${p.numero};${p.fechaDesde};${p.cedula};${p.nombre};${p.cedulaMedico}\n`;
      });
      const link = document.createElement("a");
      link.setAttribute("href", encodeURI(csv));
      link.setAttribute("download", `Atenciones_tramite_${this.p_tramite.idTramite}.csv`);
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
    },
    exportarEmpresaCSV() {
      if (!this.planillas.length) {
        Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning" }); return;
      }
      const headers = ["ID Planilla","Número","Fecha de atención","Cédula","Nombre",
                       "Cédula médico","Diag1","Diag2","Estado AM","Estado GD"];
      const content = [
        "\uFEFF" + headers.join(";"),
        ...this.planillasOrdenadas.map(p =>
          [p.idPlanilla,p.numero,p.fechaDesde,p.cedula,p.nombre,
           p.cedulaMedico,p.diag1,p.diag2,p.estadoAud,p.estadoDoc]
          .map(v => `"${(v ?? '').toString().replace(/"/g, '""')}"`)
          .join(";")
        )
      ].join("\n");
      const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href     = URL.createObjectURL(blob);
      link.download = `atenciones_tramite_${this.p_tramite.idTramite}.csv`;
      link.style.visibility = "hidden";
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
    },
    exportToExcel() {
      if (!this.planillas.length) {
        Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning" }); return;
      }
      const headers = ["ID Planilla","Número","Fecha de atención","Cédula","Nombre",
                       "Cédula médico","Diag1","Diag2","Estado AM","Estado GD"];
      const data = this.planillasOrdenadas.map(r =>
        [r.idPlanilla,r.numero,r.fechaDesde,r.cedula,r.nombre,
         r.cedulaMedico,r.diag1,r.diag2,r.estadoAud,r.estadoDoc]
      );
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Observaciones");
      XLSX.writeFile(wb, `atenciones_tramite_${this.p_tramite.idTramite}.xlsx`);
    },
getFechaDesdeByIdCarga(idCarga) {
  const carga = this.cargaMap[idCarga];
  return carga ? this.getFormattedDate(carga.fechaDesde) : idCarga;
},
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}
thead tr:nth-child(2) th {
  cursor: default;
  font-weight: normal;
  padding: 4px 6px;
}
thead tr:nth-child(2) th input,
thead tr:nth-child(2) th select {
  font-weight: normal;
  color: #212529;
}
</style>